<template>
  <div class="app-container">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="@/assets/won.gif" alt="Logo" class="logo-image" />
    </div>
    
    <!-- Header Section -->
    <div v-if="!noActiveMatch && !loading && isCombination" class="header-section">
      <div class="header-content">
        <div class="header-left">
          <h1 class="header-title">{{ combination?.name || 'Test kombine bonusu' }}</h1>
          <p class="header-subtitle">{{ combination?.description || 'Kombine etkinliği açıklaması' }}</p>
          <div class="info-pills">
            <div class="pill">
              <svg class="pill-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>{{ matches?.length || 0 }} Maç</span>
            </div>
            <div class="pill">
              <svg class="pill-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>Son Tarih: {{ formatDate(combination?.end_date) }}</span>
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="timestamp">
            <svg class="clock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>{{ currentTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Matches Section -->
    <div class="matches-container">
      <div v-if="loading" class="loading-message">
        Yükleniyor
      </div>
      
      <div v-else-if="noActiveMatch" class="no-match-message">
        Aktif maç yok
      </div>
      
      <template v-else-if="matches && matches.length > 0">
        <div v-for="(match, matchIndex) in matches" :key="match.id" class="match-card">
        <div class="match-header">
          <div class="match-title">
            <div class="match-number">{{ matchIndex + 1 }}</div>
            <span>{{ match.team_home }} vs {{ match.team_away }}</span>
          </div>
          <div class="match-timestamp">
            <svg class="clock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>{{ formatDateTime(match.match_datetime) }}</span>
          </div>
        </div>

        <!-- Betting Options Grid -->
        <div class="options-grid">
          <div v-for="option in predictionOptions" :key="option.id" class="option-card">
            <div class="option-title">{{ option.title }}</div>
            <div class="option-buttons">
              <button 
                v-for="(opt, optIdx) in option.options" 
                :key="optIdx"
                class="option-btn"
                :class="{ 'selected': form.selections[`${match.id}_${option.id}`] === opt }"
                @click="selectOption(match.id, option.id, opt)"
                type="button"
              >
                {{ opt }}
              </button>
            </div>
          </div>
        </div>
        </div>
      </template>

      <div v-else-if="singleMatch" class="match-card">
        <div class="match-header">
          <div class="match-title">
            <div class="match-number">1</div>
            <span>{{ singleMatch.team_home }} vs {{ singleMatch.team_away }}</span>
          </div>
          <div class="match-timestamp">
            <svg class="clock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>{{ formatDateTime(singleMatch.match_datetime) }}</span>
          </div>
        </div>

        <!-- Betting Options Grid -->
        <div class="options-grid">
          <div v-for="option in predictionOptions" :key="option.id" class="option-card">
            <div class="option-title">{{ option.title }}</div>
            <div class="option-buttons">
              <button 
                v-for="(opt, optIdx) in option.options" 
                :key="optIdx"
                class="option-btn"
                :class="{ 'selected': form.selections[`${singleMatch.id}_${option.id}`] === opt }"
                @click="selectOption(singleMatch.id, option.id, opt)"
                type="button"
              >
                {{ opt }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Section -->
    <div v-if="!noActiveMatch && !loading" class="footer-section">
      <form @submit.prevent="handleSubmit">
        <label class="footer-label">Kullanıcı Adınız:</label>
        <input 
          type="text" 
          v-model="form.kullaniciadi" 
          class="footer-input"
          placeholder="Kullanıcı adınızı giriniz"
          required
        />
        <button type="submit" class="submit-btn">
          <svg class="submit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
          <span>Tahminleri Gönder</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "BahisCasinoForm",
  data() {
    return {
      combination: null,
      matches: [],
      singleMatch: null,
      predictionOptions: [],
      form: {
        kullaniciadi: "",
        selections: {},
      },
      currentTime: "",
      timeInterval: null,
      noActiveMatch: false,
      loading: true,
      isCombination: false,
    };
  },
  mounted() {
    this.updateCurrentTime();
    this.timeInterval = setInterval(() => {
      this.updateCurrentTime();
    }, 1000);

    // API isteği
    this.loading = true;
    axios
      .get("https://rfnode.xyz/app/tahmin/macgetirwon")
      .then((response) => {
        console.log("API isteği başarılı:", response);
        this.loading = false;
        
        // Eğer success: false ise, aktif maç yok mesajı göster
        if (response.data.success === false) {
          this.noActiveMatch = true;
          return;
        }
        
        const data = response.data.data;
        
        if (response.data.is_combination) {
          this.isCombination = true;
          this.combination = data.combination;
          this.matches = data.matches || [];
          this.predictionOptions = data.prediction_options || [];
          
          // Initialize selections for each match
          this.matches.forEach((match) => {
            this.predictionOptions.forEach((option) => {
              this.form.selections[`${match.id}_${option.id}`] = "";
            });
          });
        } else {
          this.isCombination = false;
          this.singleMatch = data.match;
          this.predictionOptions = data.prediction_options || [];
          
          // Initialize selections for single match
          this.predictionOptions.forEach((option) => {
            this.form.selections[`${this.singleMatch.id}_${option.id}`] = "";
          });
        }
      })
      .catch((error) => {
        console.log("API isteği hatası:", error);
        this.loading = false;
        this.noActiveMatch = true;
      });
  },
  beforeUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
  methods: {
    updateCurrentTime() {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.currentTime = `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    loadSampleData() {
      // Örnek kombine veriler
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const dayAfter = new Date();
      dayAfter.setDate(dayAfter.getDate() + 2);
      
      this.combination = {
        id: 1,
        name: "Test kombine bonusu",
        description: "Kombine etkinliği açıklaması",
        start_date: tomorrow.toISOString().split('T')[0],
        end_date: dayAfter.toISOString().split('T')[0]
      };
      
      this.matches = [
        {
          id: 1,
          team_home: "Liverpool",
          team_away: "Real Madrid",
          match_datetime: `${tomorrow.toISOString().split('T')[0]} 20:00:00`
        },
        {
          id: 2,
          team_home: "Galatasaray",
          team_away: "Fenerbahçe",
          match_datetime: `${dayAfter.toISOString().split('T')[0]} 19:00:00`
        }
      ];
      
      this.predictionOptions = [
        {
          id: 1,
          title: "Maç Sonucu",
          options: ["Ev Sahibi Kazanır", "Deplasman Kazanır", "Beraberlik"]
        },
        {
          id: 2,
          title: "İlk Yarı Sonucu",
          options: ["Ev Sahibi Önde", "Deplasman Önde", "Eşitlik"]
        },
        {
          id: 3,
          title: "Toplam Gol",
          options: ["0-1 Gol", "2-3 Gol", "4+ Gol"]
        },
        {
          id: 4,
          title: "İlk Golü Atan",
          options: ["Ev Sahibi", "Deplasman", "Gol Olmaz"]
        },
        {
          id: 5,
          title: "Hangi Yarı Daha Gol Dolu",
          options: ["1 yarı", "2. yarı", "Eşit"]
        }
      ];
      
      // Initialize selections for each match
      this.matches.forEach((match) => {
        this.predictionOptions.forEach((option) => {
          this.form.selections[`${match.id}_${option.id}`] = "";
        });
      });
    },
    selectOption(matchId, optionId, value) {
      const key = `${matchId}_${optionId}`;
      if (this.form.selections[key] === value) {
        this.form.selections[key] = "";
      } else {
        this.form.selections[key] = value;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "06.11.2025";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    handleSubmit() {
      if (!this.form.kullaniciadi.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Eksik Bilgi',
          text: 'Lütfen kullanıcı adınızı giriniz.',
          confirmButtonColor: '#d33',
          confirmButtonText: 'Tamam'
        });
        return;
      }

      // Check if all selections are made
      const allSelections = Object.values(this.form.selections);
      const hasEmptySelection = allSelections.some(sel => !sel || sel === "");
      
      if (hasEmptySelection) {
        Swal.fire({
          icon: 'warning',
          title: 'Eksik Seçim',
          text: 'Lütfen tüm seçenekleri doldurunuz.',
          confirmButtonColor: '#d33',
          confirmButtonText: 'Tamam'
        });
        return;
      }

      const payload = {
        username: this.form.kullaniciadi,
      };

      // Prepare payload based on whether it's combination or single match
      if (this.combination && this.matches.length > 0) {
        // Kombine için
        payload.combination_id = this.combination.id;
        payload.predictions = [];
        
        this.matches.forEach((match) => {
          this.predictionOptions.forEach((option) => {
            const key = `${match.id}_${option.id}`;
            const selectedOption = this.form.selections[key];
            if (selectedOption) {
              payload.predictions.push({
                match_id: match.id,
                prediction_option_id: option.id,
                selected_option: selectedOption,
              });
            }
          });
        });
      } else if (this.singleMatch) {
        // Tekil maç için
        payload.match_id = this.singleMatch.id;
        payload.predictions = [];
        
        this.predictionOptions.forEach((option) => {
          const key = `${this.singleMatch.id}_${option.id}`;
          const selectedOption = this.form.selections[key];
          if (selectedOption) {
            payload.predictions.push({
              prediction_option_id: option.id,
              selected_option: selectedOption,
            });
          }
        });
      }

      console.log("Gönderilen payload:", payload);

      axios
        .post("https://rfnode.xyz/app/tahmin/mactahminyapwon", payload)
        .then(() => {
          this.form.kullaniciadi = "";
          Object.keys(this.form.selections).forEach(key => {
            this.form.selections[key] = "";
          });
          Swal.fire({
            icon: 'success',
            title: 'Tahmin gönderildi!',
            text: 'Tahmininiz başarıyla kaydedildi.',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Tamam'
          });
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Hata',
            text: 'Zaten tahmininiz var',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Tamam'
          });
        });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #000000;
  color: #ffffff;
  font-family: "Poppins", sans-serif;
}

p,
label {
  color: #e0e0e0;
  font-weight: bold;
  font-size: 22px;
}

.app-container {
  min-height: 100vh;
  background-color: #000000;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo Section */
.logo-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.logo-image {
  max-width: 150px;
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Header Section */
.header-section {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 40px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.header-left {
  flex: 1;
}

.header-title {
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 8px;
}

.header-subtitle {
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 16px;
  opacity: 0.9;
}

.info-pills {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(212, 175, 55, 0.2);
  border: 1px solid rgba(212, 175, 55, 0.4);
  padding: 8px 16px;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.pill-icon {
  width: 18px;
  height: 18px;
  stroke: currentColor;
}

.header-right {
  display: flex;
  align-items: center;
}

.timestamp {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(212, 175, 55, 0.4);
  padding: 6px 12px;
  border-radius: 6px;
  box-shadow: 0 8px 25px rgba(192, 192, 192, 0.3), inset 0 0 20px rgba(192, 192, 192, 0.15);
}

.clock-icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
}

/* Matches Container */
.matches-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;
}

.no-match-message,
.loading-message {
  text-align: center;
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  padding: 40px 20px;
  background-color: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(212, 175, 55, 0.4);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(192, 192, 192, 0.3), inset 0 0 20px rgba(192, 192, 192, 0.15);
  backdrop-filter: blur(8px);
}

.match-card {
  background-color: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(212, 175, 55, 0.4);
  box-shadow: 0 8px 25px rgba(192, 192, 192, 0.3), inset 0 0 20px rgba(192, 192, 192, 0.15);
  border-radius: 12px;
  padding: 24px;
  color: #ffffff;
  backdrop-filter: blur(8px);
}

.match-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.match-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.match-number {
  width: 32px;
  height: 32px;
  background: rgba(212, 175, 55, 0.6);
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.6);
}

.match-timestamp {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  font-size: 14px;
}

/* Options Grid */
.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.option-card {
  background: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(212, 175, 55, 0.4);
  box-shadow: 0 8px 25px rgba(192, 192, 192, 0.3), inset 0 0 20px rgba(192, 192, 192, 0.15);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  backdrop-filter: blur(8px);
}

.option-title {
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
  text-align: left;
  width: 100%;
  line-height: 1.4;
}

.option-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.option-btn {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  border: 1px solid #d4af37;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  box-shadow: inset 0px 0 15px rgba(212, 175, 55, 0.3);
}

.option-btn:hover {
  background: rgba(212, 175, 55, 0.2);
  border-color: #c0c0c0;
  box-shadow: 0 0 10px rgba(192, 192, 192, 0.6);
}

.option-btn.selected {
  background: rgba(212, 175, 55, 0.4);
  color: #ffffff;
  border-color: #c0c0c0;
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.8);
}

/* Footer Section */
.footer-section {
  width: 100%;
  max-width: 1200px;
}

.footer-section form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.footer-input {
  background-color: rgba(0, 0, 0, 0.85);
  border: 1px solid #d4af37;
  box-shadow: inset 0px 0 15px rgba(212, 175, 55, 0.3);
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 16px;
  color: white;
  height: 45px;
  width: 100%;
  transition: all 0.3s ease;
}

.footer-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.footer-input:focus {
  outline: none;
  border-color: #c0c0c0;
  box-shadow: 0 0 10px rgba(192, 192, 192, 0.6);
}

.submit-btn {
  display: flex;
  font-family: inherit;
  font-size: 1.1em;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  height: 50px;
  text-transform: uppercase;
  width: 100%;
  background: linear-gradient(160deg, #d4af37, #c0c0c0, #d4af37);
  color: #000000;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 6px 20px rgba(192, 192, 192, 0.4);
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.submit-btn:hover {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2),
              0 4px 6px rgba(0, 0, 0, 0.3),
              inset 0 -2px 5px 1px #d4af37,
              inset 0 -1px 1px 3px rgba(192, 192, 192, 0.9);
  transform: translateY(-2px);
}

.submit-btn:active {
  transform: scale(0.98);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
              0 3px 6px rgba(192, 192, 192, 0.4),
              inset 0 -2px 5px 1px #d4af37,
              inset 0 -1px 1px 3px rgba(192, 192, 192, 0.9);
}

.submit-icon {
  width: 20px;
  height: 20px;
  stroke: currentColor;
}

option {
  color: white;
  font-weight: bold;
  font-size: 24px;
}

.vs {
  text-align: center;
  font-size: 22px;
  color: #d4af37;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(212, 175, 55, 0.8);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
  }

  .header-title {
    font-size: 24px;
  }

  .options-grid {
    grid-template-columns: 1fr;
  }

  .match-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>